import { Box, Button, TextField, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { DEVICE_VITAL_COMPONENTS_ARRAY, safeRangeKeys } from './Constant'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import useCustomStyles from '../../../../utils/hooks/CustomStylesHook'
import { useParams } from 'react-router-dom'
import { setVitalRanges } from '../../../../services/DeviceServices'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import { selectSafeRanges, updateSafeRanges } from './DeviceSlice'
import { toast } from 'react-toastify'

const styles = () => ({
  container: {
    width: '70%',
  },
  vitalRangeField: {
    width: '100px',
    fontSize: '12px',
  },
  tableHeadCell: {
    background: '#4682b4',
    color: '#ffffff',
  },
  tableBodyCell: {},
  submitBtn: {
    background: '#4682b4',
    textTransform: 'capitalize',
  },
})
const VitalRange = () => {
  const { id }: any = useParams()
  const dispatch = useAppDispatch()
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [loading, setLoading] = useState(false)
  const safeRanges = useAppSelector(selectSafeRanges)
  const [deviceVitalRanges, setDeviceVitalRanges] = useState<any>({
    heartRateMin: safeRanges?.[safeRangeKeys?.HEARTRATE]?.min,
    heartRateMax: safeRanges?.[safeRangeKeys?.HEARTRATE]?.max,
    spo2Min: safeRanges?.[safeRangeKeys?.SPO2]?.min,
    spo2Max: safeRanges?.[safeRangeKeys?.SPO2]?.max,
    bloodPressureSystolicMin:
      safeRanges?.[safeRangeKeys?.BLOODPRESSURESYSTOLIC]?.min,
    bloodPressureSystolicMax:
      safeRanges?.[safeRangeKeys?.BLOODPRESSURESYSTOLIC]?.max,
    bloodPressureDiastolicMin:
      safeRanges?.[safeRangeKeys?.BLOODPRESSUREDIASTOLIC]?.min,
    bloodPressureDiastolicMax:
      safeRanges?.[safeRangeKeys?.BLOODPRESSUREDIASTOLIC]?.max,
    respiratoryRateMin: safeRanges?.[safeRangeKeys?.RESPIRATORYRATE]?.min,
    respiratoryRateMax: safeRanges?.[safeRangeKeys?.RESPIRATORYRATE]?.max,
    skinTemperatureMin: safeRanges?.[safeRangeKeys?.SKINTEMPERATURE]?.min,
    skinTemperatureMax: safeRanges?.[safeRangeKeys?.SKINTEMPERATURE]?.max,
    heartRateVarMin: safeRanges?.[safeRangeKeys?.HEARTRATEVAR]?.min,
    heartRateVarMax: safeRanges?.[safeRangeKeys?.HEARTRATEVAR]?.max,
    stressMin: safeRanges?.[safeRangeKeys?.STRESS]?.min,
    stressMax: safeRanges?.[safeRangeKeys?.STRESS]?.max,
    sleepMin: safeRanges?.[safeRangeKeys?.SLEEP]?.min,
    sleepMax: safeRanges?.[safeRangeKeys?.SLEEP]?.max,
    bloodGlucoseMin: safeRanges?.[safeRangeKeys?.BLOODGLUCOSE]?.min,
    bloodGlucoseMax: safeRanges?.[safeRangeKeys?.BLOODGLUCOSE]?.max,
  })

  const handleFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    setDeviceVitalRanges((prev: any) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handlePostSafeRanges = async () => {
    setLoading(true)
    const apiPayload = {
      encounterId: id,
      ...deviceVitalRanges,
    }

    const reduxPayload = {
      heartRate: {
        min: deviceVitalRanges?.heartRateMin,
        max: deviceVitalRanges?.heartRateMax,
      },
      spo2: {
        min: deviceVitalRanges?.spo2Min,
        max: deviceVitalRanges?.spo2Max,
      },
      bloodPressureSystolic: {
        min: deviceVitalRanges?.bloodPressureSystolicMin,
        max: deviceVitalRanges?.bloodPressureSystolicMax,
      },
      bloodPressureDiastolic: {
        min: deviceVitalRanges?.bloodPressureDiastolicMin,
        max: deviceVitalRanges?.bloodPressureDiastolicMax,
      },
      skinTemperature: {
        min: deviceVitalRanges?.skinTemperatureMin,
        max: deviceVitalRanges?.skinTemperatureMax,
      },
      respiratoryRate: {
        min: deviceVitalRanges?.respiratoryRateMin,
        max: deviceVitalRanges?.respiratoryRateMax,
      },
      heartRateVar: {
        min: deviceVitalRanges?.heartRateVarMin,
        max: deviceVitalRanges?.heartRateVarMax,
      },
      stress: {
        min: deviceVitalRanges?.stressMin,
        max: deviceVitalRanges?.stressMax,
      },
      sleep: {
        min: deviceVitalRanges?.sleepMin,
        max: deviceVitalRanges?.sleepMax,
      },
      bloodGlucose: {
        min: deviceVitalRanges?.bloodGlucoseMin,
        max: deviceVitalRanges?.bloodGlucoseMax,
      },
    }
    dispatch(updateSafeRanges(reduxPayload))
    const response = await setVitalRanges(apiPayload)
    if (response?.success) {
      toast.success(response?.message)
    } else {
      toast.error(response?.message)
    }
    setLoading(false)
  }

  return (
    <Box className={classes?.container}>
      <TableContainer component={Paper}>
        <Table
          size='small'
          aria-label='simple table'
          sx={{ minWidth: 650 }}
          stickyHeader
        >
          <TableHead>
            <TableRow>
              <TableCell className={classes?.tableHeadCell}>
                Vital Component
              </TableCell>
              <TableCell className={classes?.tableHeadCell}>Minimum</TableCell>
              <TableCell className={classes?.tableHeadCell}>Maximum</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {DEVICE_VITAL_COMPONENTS_ARRAY.map((item, index) => (
              <TableRow key={index}>
                <TableCell component='th' scope='row'>
                  {item?.label}
                </TableCell>
                <TableCell>
                  <TextField
                    name={`${item?.value}Min`}
                    value={deviceVitalRanges?.[`${item?.value}Min`]}
                    size='small'
                    type='number'
                    className={classes?.vitalRangeField}
                    placeholder='Min'
                    onChange={handleFieldChange}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    name={`${item?.value}Max`}
                    value={deviceVitalRanges?.[`${item?.value}Max`]}
                    size='small'
                    type='number'
                    className={classes?.vitalRangeField}
                    placeholder='Max'
                    onChange={handleFieldChange}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box mt={2} textAlign={'center'}>
        <Button
          disabled={loading}
          size='small'
          variant='contained'
          className={classes?.submitBtn}
          onClick={handlePostSafeRanges}
        >
          Submit
        </Button>
      </Box>
    </Box>
  )
}

export default VitalRange
